module.exports = __webpack_public_path__ + "static/media/ND-Trigger-Artwork-1000x1000.91060751.jpg";